"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Link", {
  enumerable: true,
  get: function get() {
    return _reactRouterDom.Link;
  }
});
exports.StepProgress = exports.StepDots = exports.StepController = exports.Step = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ = require("../../");

var _reactRouterDom = require("react-router-dom");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */
var STEP_ID = 0;

var StepController = function StepController(_ref) {
  var step = _ref.step,
      children = _ref.children;
  var steps = [];
  var uniqueID = 'trkl' + STEP_ID++;
  var i = Date.now();

  _react.default.Children.forEach(children, function (child) {
    if (child.props.name === step) {
      steps.push(child);
    }

    i++;
  });

  steps.push( /*#__PURE__*/_react.default.createElement("div", {
    className: uniqueID,
    key: "step-controller-hidden-div"
  })); // track changes to step

  (0, _react.useEffect)(function () {
    (0, _.trackEvent)({
      action: "Step ".concat(step),
      element: document.querySelector(".".concat(uniqueID))
    });
  }, [step]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, steps);
};

exports.StepController = StepController;

var Step = function Step(props) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, props.children);
};

exports.Step = Step;

var StepDots = function StepDots(_ref2) {
  var steps = _ref2.steps,
      index = _ref2.index;
  var dots = [];

  for (var i = 0; i < steps; i++) {
    var ml = i === 0 ? 0 : 4;
    dots.push( /*#__PURE__*/_react.default.createElement(_.Element, {
      tag: "a",
      className: i === index ? "dot active" : "dot",
      marginLeft: ml,
      href: "#step-".concat(i)
    }, "Step ", i));
  }

  return /*#__PURE__*/_react.default.createElement(_.Row, {
    className: "dots",
    spacingTop: "4",
    spacingBottom: "4",
    center: true
  }, dots);
};

exports.StepDots = StepDots;

var StepProgress = function StepProgress(_ref3) {
  var steps = _ref3.steps,
      index = _ref3.index;
  var stylesProgress = {
    width: "".concat(index / steps * 100, "%"),
    maxWidth: '100%'
  };
  return /*#__PURE__*/_react.default.createElement(_.Element, {
    className: "step-progress"
  }, /*#__PURE__*/_react.default.createElement(_.Element, {
    className: "progress-bar-inner",
    style: stylesProgress
  }), /*#__PURE__*/_react.default.createElement(_.Element, {
    className: "progress-bar-outer"
  }));
};

exports.StepProgress = StepProgress;